import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import type { User } from 'oidc-client-ts';
import * as Sentry from "@sentry/react";
import { config } from './config';
import { isSafeReturnPath, takeReturnTo } from './auth/signIn';

const oidcConfig = {
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: `${window.location.origin}`,
  // Return to the page that triggered the sign-in (stored in the state by App, and in storage) and drop the code/state query params
  onSigninCallback: (user: User | void) => {
    const returnTo = (user?.state as { returnTo?: string } | undefined)?.returnTo;
    const remembered = takeReturnTo();
    const target = isSafeReturnPath(returnTo) ? returnTo : remembered ?? window.location.pathname;
    window.history.replaceState({}, document.title, target);
  }
};

Sentry.init({
  dsn: "https://1ad1631223e9e4efe809bcfa5a02803a@o4510948712054784.ingest.de.sentry.io/4510971094958160",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/*.cppmodel\.com/]
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
